export const applyThemeByUserType = (isCompany: boolean | undefined | null): void => {
    if (typeof window === "undefined") return;

    const isMono = Boolean(isCompany);
    document.cookie = `isMonoTheme=${isMono ? "true" : ""}; path=/; max-age=31536000; SameSite=Lax`;

    document.body.classList.remove("theme-mono");
    if (isMono) document.body.classList.add("theme-mono");
};